import { render, staticRenderFns } from "./p.vue?vue&type=template&id=42415e57&scoped=true&lang=pug&"
import script from "./p.vue?vue&type=script&lang=ts&"
export * from "./p.vue?vue&type=script&lang=ts&"
import style0 from "./p.vue?vue&type=style&index=0&id=42415e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42415e57",
  null
  
)

/* custom blocks */
import block0 from "./p.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./p.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingTips: require('/app/src/components/atoms/LoadingTips.vue').default,ButtonShare: require('/app/src/components/atoms/ButtonShare.vue').default,ButtonBookmark: require('/app/src/components/atoms/ButtonBookmark.vue').default,TitleBar: require('/app/src/components/molecules/TitleBar.vue').default,IFrameVideo: require('/app/src/components/atoms/IFrameVideo.vue').default,LoadImage: require('/app/src/components/atoms/LoadImage.vue').default,CorporationInfo: require('/app/src/components/molecules/CorporationInfo.vue').default,IconSchool: require('/app/src/components/atoms/IconSchool.vue').default,ShowMoreContent: require('/app/src/components/atoms/ShowMoreContent.vue').default,ShowMoreWorkingPlaceContent: require('/app/src/components/atoms/ShowMoreWorkingPlaceContent.vue').default,SectionOffice: require('/app/src/components/molecules/SectionOffice.vue').default,SectionJobs: require('/app/src/components/molecules/SectionJobs.vue').default,SectionSeminar: require('/app/src/components/molecules/SectionSeminar.vue').default,SectionInternship: require('/app/src/components/molecules/SectionInternship.vue').default,SectionFeeds: require('/app/src/components/molecules/SectionFeeds.vue').default})
